import { ThemeComponent } from '@/theme/ThemeComponent';
import { Component, SimpleEvent } from '@eastsideco/salvo-ts';

@Component
export class AccordionHeader extends ThemeComponent {

    private open: string = '';

    private _onOpenChange = new SimpleEvent<string>();

    public get onOpenChange() {
        return this._onOpenChange.asEvent();
    }

    public changeOpen(open: string) {
        this.open = open;
        this._onOpenChange.dispatch(open);
    }

    init() {
        this.$listen(this, 'click', () => {
            this._onOpenChange.dispatch(this.open);
        });
    }
}
